import React, { ReactNode } from 'react';
import styles from './ErrorBoxLayout.module.css';

export default function ErrorBoxLayout({ children }: { children: ReactNode }) {
  return (
    <div className={styles.content}>
      <div className={styles.box}>{children}</div>
    </div>
  );
}
